import { Translation } from '../translation';

/**
 * Search command for production cards paginated search
 */
export interface ProductionCardSearchCommandPaginated {
  productionCardNumbers?: string[];
  assetIds?: string[];
  dyeingForecastReferences?: string[];
  statuses?: ProductionCardStatus[];
  workOrderReferences?: string[];
  clientPOs?: string[];
  colorReferences?: string[];
  locationCodes?: string[];
}

/**
 * Production card status enum
 */
export enum ProductionCardStatus {
  Draft = 0,
  Submitted = 1,
  Approved = 2,
  PlanningForBatching = 3,
  InRouteToBatching = 4,
  Batching = 5,
  InRouteToBrd = 6,
  Brd = 7,
  Deleted = 8,
  Rejected = 9,
  Dyeing = 10,
  ReadyForFinishing = 11,
  Finishing = 12,
  FinishedGood = 13,
  Shipped = 14,
}

/**
 * Numbered document key for references
 */
export interface NumberedDocumentKey {
  reference?: string;
  number?: string;
}

/**
 * Coded document key for entities with code and name
 */
export interface CodedDocumentKey {
  reference?: string;
  code?: string;
  name?: string;
}

/**
 * Fabric form enum
 */
export enum FabricForm {
  Open = 0,
  Tubular = 1,
}

/**
 * Production card search result item
 */
export interface ProductionCardResultItem {
  productionCard: NumberedDocumentKey;
  colorName?: string;
  labDipNumber?: string;
  currentLocationName?: Translation;
  workOrder: NumberedDocumentKey;
  client: CodedDocumentKey;
  brand: CodedDocumentKey;
  clientPO?: string;
  fabricCode?: string;
  fabricDescription?: string;
  fabricForm?: FabricForm;
  totalKg: number;
  totalLbs: number;
  totalYards: number;
  totalRolls: number;
  averageWeightPerRoll: number;
}

/**
 * Helper to get status display name
 */
export function getProductionCardStatusLabel(status: ProductionCardStatus): Translation {
  const labels: Record<ProductionCardStatus, Translation> = {
    [ProductionCardStatus.Draft]: { es: 'Borrador', en: 'Draft' },
    [ProductionCardStatus.Submitted]: { es: 'Enviado', en: 'Submitted' },
    [ProductionCardStatus.Approved]: { es: 'Aprobado', en: 'Approved' },
    [ProductionCardStatus.PlanningForBatching]: { es: 'Planificación Batching', en: 'Planning for Batching' },
    [ProductionCardStatus.InRouteToBatching]: { es: 'En Ruta a Batching', en: 'In Route to Batching' },
    [ProductionCardStatus.Batching]: { es: 'Batching', en: 'Batching' },
    [ProductionCardStatus.InRouteToBrd]: { es: 'En Ruta a BRD', en: 'In Route to BRD' },
    [ProductionCardStatus.Brd]: { es: 'BRD', en: 'BRD' },
    [ProductionCardStatus.Deleted]: { es: 'Eliminado', en: 'Deleted' },
    [ProductionCardStatus.Rejected]: { es: 'Rechazado', en: 'Rejected' },
    [ProductionCardStatus.Dyeing]: { es: 'Teñido', en: 'Dyeing' },
    [ProductionCardStatus.ReadyForFinishing]: { es: 'Listo para Acabado', en: 'Ready for Finishing' },
    [ProductionCardStatus.Finishing]: { es: 'Acabado', en: 'Finishing' },
    [ProductionCardStatus.FinishedGood]: { es: 'Producto Terminado', en: 'Finished Good' },
    [ProductionCardStatus.Shipped]: { es: 'Enviado', en: 'Shipped' },
  };
  return labels[status] || { es: 'Desconocido', en: 'Unknown' };
}
